import { Button, Col, Form, Modal, Row } from "react-bootstrap";
import { Form as FormAnt, Upload } from "antd";
import { InboxOutlined, FilePdfOutlined, FileWordOutlined, FileOutlined } from "@ant-design/icons";
import { useState } from "react";

const AgregarInmueble = ({ show, handleClose, setInmuebles }) => {
  const [data, setData] = useState({});
  const [documentos, setDocumentos] = useState([]);

  const onSubmit = (e) => {
    e.preventDefault();
    
    setInmuebles((prev) => [...prev, { ...data, documentos }]);
    handleClose();
  };

  const normFile = (e) => {
    setDocumentos(e.fileList);
    if (Array.isArray(e)) {
      return e;
    }
    return e && e.fileList;
  };

  const handleChange = (e) => {
    setData({
      ...data,
      [e.target.name]: e.target.value
    });
  };


  return (
    <Modal
      animation={false}
      show={show}
      onHide={handleClose}
      size="xl"
      className="contribuyente-modal"
      backdrop="static"
    >
      <Modal.Header closeButton />
      <Modal.Body>

        <Form className="contribuyente-form" onSubmit={onSubmit}>
          <Row style={{ marginBottom: 50 }}>
            <Col sm={12} md={6}>
              <div className="contribuyente-title">
                <span>Agregar inmueble</span>
              </div>
            </Col>
          </Row>
          <Row className="pb-2">
            <Col sm={12} md={12}>
              <Form.Label className="mb-2" style={{ marginTop: 10 }}>
                Inmueble
              </Form.Label>
              <Form.Control
                name="inmueble"
                onChange={handleChange}
                required
              />
            </Col>
          </Row>
          <br />
          <Row className="pb-2">
            <Col sm={12} md={12}>
              <Form.Label className="mb-2" style={{ marginTop: 10 }}>
                Recurso
              </Form.Label>
              <Form.Control
                name="recurso"
                onChange={handleChange}
                required
              />
            </Col>
          </Row>
          <br />
          <Row className="pb-2">
            <Col sm={12} md={12}>
              <Form.Label className="mb-2" style={{ marginTop: 10 }}>
                Caracter
              </Form.Label>
              <Form.Control
                name="caracter"
                onChange={handleChange}
              />
            </Col>
          </Row>
          <br />
          <Row className="pb-2">
            <Col sm={12} md={12}>
              <Form.Label className="mb-2">Observaciones</Form.Label>
              <Form.Control
                as="textarea"
                name="observaciones"
                rows={5}
                onChange={handleChange}
              />
            </Col>
          </Row>
          <br />
          <Row className="pb-2">
            <Col sm={12} md={12} >
              <FormAnt.Item>
                <Form.Label className="mb-2">
                  Subir archivos:
                </Form.Label>
                <FormAnt.Item name="dragger" valuePropName="fileList" getValueFromEvent={normFile} >
                  <Upload.Dragger
                    multiple
                    beforeUpload={() => false}
                    name="files"
                    listType="picture"
                    iconRender={(f) => {
                      if (f.type === "application/pdf") {
                        return <FilePdfOutlined style={{ color: "#FA0F00" }} />;
                      }
                      else if ((f.type === "application/msword") || (f.type === "application/vnd.openxmlformats-officedocument.wordprocessingml.document")) {
                        return <FileWordOutlined style={{ color: "#185ABD" }} />;
                      }
                      else {
                        return <FileOutlined />;
                      }
                    }}
                  >
                    <p className="ant-upload-drag-icon">
                      <InboxOutlined />
                    </p>
                    <p className="ant-upload-text">Haga click o arrastre el archivo a esta área para cargarlo</p>
                    <p className="ant-upload-hint">Soporte para una carga única o masiva.</p>
                  </Upload.Dragger>
                </FormAnt.Item>
              </FormAnt.Item>
            </Col>
          </Row>

          <Row className="justify-content-end">
            <Col style={{ maxWidth: 190 }}>
              <Button
                className="custom-button"               
                type="submit"
              >
                <span className="ml-2">Guardar Inmueble</span>
              </Button>
            </Col>
            <Col style={{ maxWidth: 140 }}>
              <Button
                className="danger-button ml-2"
                variant="danger"
                onClick={handleClose}
              >
                <span className="ml-2">Cancelar</span>
              </Button>
            </Col>
          </Row>
        </Form>

      </Modal.Body>
    </Modal>
  );
};


export default AgregarInmueble;
